(ns ^:dev/always bp-clients.tv-app.api.graphql.user
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/user/user.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private user-raw (get-in query-map [:query :user]))

(defn user-info-query
  "Queries user info"
  []
  (query-builder user-raw))

(comment
  ;; see the corresponding .graphql files for more impormation
  (user-info-query))
